<template>
  <div  class="min-h-screen flex flex-col">
    
       <header class="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur">
      <div class="container mx-auto px-4">
        <div class="flex h-16 items-center justify-between">
          <!-- Logo -->
          <router-link to="/" class="flex items-center space-x-2">
            <img class="w-full h-20 object-cover object-center" :src="logo" alt="">
          </router-link>

          <!-- Desktop Navigation -->
          <nav class="hidden lg:flex items-center space-x-6"  >
            <!-- Categories Dropdown -->
            <div 
              class="relative"
              @mouseenter="showCategoryDropdown = true"
             @click="showCategoryDropdown = !showCategoryDropdown"
            >
              <button class="flex items-center text-sm font-medium text-foreground hover:text-secondary transition-normal">
                Catégories
                <icon name="ChevronDown" class="ml-1 h-4 w-4" />
              </button>
              
              <div 
                @mouseenter="showCategoryDropdown = true"
              @mouseleave="showCategoryDropdown = false"
                v-if="showCategoryDropdown"
                class="absolute top-full left-0 mt-2 w-48 bg-background border border-border rounded-lg shadow-lg py-2 z-50"
              >
                <router-link
                  v-for="category in categories"
                  :key="category.id"
                  :to="'/category/'+category.slug"
                  class="block px-4 py-2 text-sm text-foreground hover:bg-muted hover:text-secondary transition-normal"
                  @click="showCategoryDropdown = false"
                >
                  {{ category.name }}
                </router-link>
              </div>
            </div>

            <router-link
              v-for="link in quickLinks"
              :key="link.name"
              :to="link.path"
              class="text-sm font-medium text-foreground hover:text-secondary transition-normal"
            >
              {{ link.name }}
            </router-link>
          </nav>

          <!-- Search Bar -->
          <form @submit.prevent="handleSearch" class="hidden md:flex items-center flex-1 max-w-md mx-6">
            <div class="relative w-full">
              <icon name="Search" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
              <input
                type="search"
                placeholder="Rechercher un produit..."
                v-model="headerSearchQuery"
                class="pl-10 pr-4 w-full px-3 py-2 border border-input bg-background rounded-lg focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-normal"
              />
            </div>
          </form>

          <!-- Actions -->
          <div class="flex items-center space-x-4">
            <router-link to="/account">
              <button class=" flex gap-2 items-center gap-2 px-3 py-1.5 text-sm text-foreground hover:text-secondary hover:bg-muted rounded-lg transition-normal">
                 <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                
                <p class="hidden md:flex">Mon Compte</p>
              </button>
            </router-link>
            
           <router-link to="/cart">
              <button class="relative p-2 text-foreground hover:text-secondary transition-colors">
                <ShoppingCart class="h-4 w-4" />
                <span class="absolute -top-2 -right-2 bg-secondary text-secondary-foreground rounded-full w-5 h-5 text-xs flex items-center justify-center">
                  {{ cartitem }}
                </span>
              </button>
            </router-link>


            <!-- Mobile Menu Button -->
            <button
              @click="isMenuOpen = !isMenuOpen"
              class="p-2 lg:hidden text-foreground hover:text-secondary hover:bg-muted rounded-lg transition-normal"
            >
              <Menu v-if="!isMenuOpen" name="Menu" class="h-4 w-4" />
              <X v-else name="X" class="h-4 w-4" />
            </button>
          </div>
        </div>

        <!-- Mobile Menu -->
        <div v-if="isMenuOpen" class="lg:hidden py-4 border-t border-border">
          <form @submit.prevent="handleSearch" class="mb-4">
            <div class="relative">
              <icon name="Search" class="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
              <input
                type="search"
                placeholder="Rechercher..."
                v-model="headerSearchQuery"
                class="pl-10 w-full px-3 py-2 border border-input bg-background rounded-lg focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-normal"
              />
            </div>
          </form>
          
          <nav class="space-y-2">
            <p class="text-xs font-semibold text-muted-foreground uppercase tracking-wider px-2 mb-2">
              Catégories
            </p>
            <router-link
              v-for="category in categories"
              :key="category.id"
              :to="'/category/'+category.slug"
              class="block py-2 px-2 text-sm font-medium text-foreground hover:text-secondary hover:bg-muted rounded transition-normal"
              @click="isMenuOpen = false"
            >
              {{ category.name }}
            </router-link>
            
            <div class="border-t border-border my-4" />
            
            <p class="text-xs font-semibold text-muted-foreground uppercase tracking-wider px-2 mb-2">
              Liens rapides
            </p>
            <router-link
              v-for="link in quickLinks"
              :key="link.name"
              :to="link.path"
              class="block py-2 px-2 text-sm font-medium text-foreground hover:text-secondary hover:bg-muted rounded transition-normal"
              @click="isMenuOpen = false"
            >
              {{ link.name }}
            </router-link>
            
            <div class="border-t border-border my-4" />
            
            <router-link
              to="/account"
              class="block py-2 px-2 text-sm font-medium text-foreground hover:text-secondary hover:bg-muted rounded transition-normal"
              @click="isMenuOpen = false"
            >
              Mon Compte
            </router-link>
          </nav>
        </div>
      </div>
    </header>
  

    <!-- Main Content -->
    <main class="flex-1">
      <router-view name="two"  :isready="isready" :getdevice="device" @AddToCart="handleAddToCart"    @updateSeo="handleUpdateSeo"/>
      <EcommerceChat></EcommerceChat>
    </main>

    <!-- Footer Component -->
     <footer class="bg-primary text-primary-foreground">
      <div class="container mx-auto px-4 py-12">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <!-- Brand -->
          <div>
            <div class="flex items-center    space-x-2 mb-4">
              <img class="w-full h-24 bg-white object-cover object-center" :src="logo" alt="">
            </div>
            <p class="text-primary-foreground/80 mb-4">
              Votre marketplace de confiance pour tous vos achats : chaussures, vêtements, électronique, beauté et bien plus encore.
            </p>
            <div class="flex space-x-4">
              <a href="#" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                <icon name="Facebook" class="h-5 w-5" />
              </a>
              <a href="#" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                <icon name="Instagram" class="h-5 w-5" />
              </a>
              <a href="#" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                <icon name="Twitter" class="h-5 w-5" />
              </a>
            </div>
          </div>

          <!-- Categories -->
          <div v-if="categories.length > 0">
            <h3 class="text-lg font-semibold mb-4">Catégories</h3>
            <ul class="  flex flex-wrap items-center gap-2"> 
              
                <router-link v-for="categorie in categories" :key="categorie.id" :to="`/category/${categorie.slug}`" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                  {{ categorie.name }}
                </router-link>
             
              
            </ul>
          </div>

          <!-- Customer Service -->
          <div>
            <h3 class="text-lg font-semibold mb-4">Service Client</h3>
            <ul class="space-y-2">
              <li>
                <router-link to="/about" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                  À propos
                </router-link>
              </li>
              <li>
                <router-link to="/contact" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                  Contact
                </router-link>
              </li>
              <li>
                <router-link to="/faq" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                  FAQ
                </router-link>
              </li>
              <li>
                <router-link to="/terms" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                  CGV
                </router-link>
              </li>
              <li>
                <router-link to="/privacy" class="text-primary-foreground/80 hover:text-secondary transition-normal">
                  Confidentialité
                </router-link>
              </li>
            </ul>
          </div>

          <!-- Contact Info -->
          <div>
            <h3 class="text-lg font-semibold mb-4">Contact</h3>
            <div class="space-y-3">
              <div class="flex items-center space-x-3">
                <icon name="MapPin" class="h-4 w-4 text-secondary" />
                <span class="text-primary-foreground/80">Douala, Cameroun</span>
              </div>
              <div class="flex items-center space-x-3">
                <icon name="Phone" class="h-4 w-4 text-secondary" />
                <span class="text-primary-foreground/80"><a href="tel:+237 6 94 11 83 10">+237 6 94 11 83 10</a></span>
              </div>
              <div class="flex items-center space-x-3">
                <icon name="Mail" class="h-4 w-4 text-secondary" />
                <span class="text-primary-foreground/80"><a href="mailto:contact@cassuss.com">contact@cassuss.com</a></span>
              </div>
            </div>
          </div>
        </div>

        <div class="border-t border-primary-foreground/20 mt-8 pt-8">
          <div class="flex flex-col md:flex-row justify-between items-center gap-4">
            <p class="text-primary-foreground/80 text-sm">
              © {{currentYear}} cassuss. Tous droits réservés.
            </p>
            <div class="flex items-center gap-4 text-sm text-primary-foreground/80">
              <span>Paiements acceptés :</span>
              <span class="font-medium">Mobile Money • Orange Money • Carte Bancaire</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import EcommerceChat from './chatcomponent.vue';
// Mise à jour pour layout.vue - Supprimer les parties liées au SEO manuel
import { mapState, mapMutations } from 'vuex';
import {ShoppingCart,
    User,
    Search,
    Menu,
    X,
    Facebook,
    Instagram,
    Twitter,
    Mail,
    Phone,
    MapPin} from 'lucide-vue-next';
export default {
  name: 'App',
  components: {
    EcommerceChat,
    ShoppingCart,
    User,
    Search,
    Menu,
    X,
    Facebook,
    Instagram,
    Twitter,
    Mail,
    Phone,
    MapPin
  },
  data() {
    return {
      logo: require('@/assets/logo.png'),
      isready: false,
      width: window.innerWidth,
      isMenuOpen: false,
      headerSearchQuery: '',
      showCategoryDropdown: false,
      quickLinks: [
        { name: 'Tendances', path: '/category/trending' },
        { name: 'Nouveautés', path: '/category/new' },
        { name: 'Promos', path: '/category/promos' }
      ]
    }
  },
 
  computed: {
   
    ...mapState(['pageMeta', 'categories']),
    
      currentYear() {
      return new Date().getFullYear()
    },
    cartitem() {
      return this.$store.state.cart.length
    },
    
    isMobile() {
      return this.width <= 768
    },
    
    isTablet() {
      return this.width > 768 && this.width <= 1024
    },
    
    isDesktop() {
      return this.width > 1024
    },
    
    device() {
      if (this.isMobile) return 'mobile'
      if (this.isTablet) return 'tablet'
      if (this.isDesktop) return 'desktop'
      return 'unknown'
    }
  },
  
  methods: {
    ...mapMutations(['addtocart']),
    
    getdevice() {
      return this.device
    },
    
    onResize() {
      this.width = window.innerWidth
    },

    handleSearch() {
      if (this.headerSearchQuery.trim()) {
        this.$router.push(`/category?q=${encodeURIComponent(this.headerSearchQuery)}`)
        this.isMenuOpen = false
      }
    },
    
    handleAddToCart(product) {
      this.$store.dispatch('addToCart', product)
    }
    
   
  },
  
  async mounted() {
    window.addEventListener('resize', this.onResize)
    
    try {
      this.loading = true
      await this.$store.dispatch('fetchOfflineData')
      this.isready = true
    } catch (error) {
      console.error('Error loading data:', error)
    } finally {
      this.loading = false
    }
  },
  
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style>
/* Styles globaux si nécessaire */
</style>